module.exports = __webpack_public_path__ + "img/play.111f3188.png";